// extracted by mini-css-extract-plugin
export default {"Empty":"Empty_Empty__xZX1c"};